import KioskStorageContainer from './kiosk-storage-container';

export default KioskStorageContainer;
